import baseURL from "@/utils/config";
import request from "@/plugins/axios";
export function queryActivityInfo(id, langEnv = 2) {
  return request({
    url: `${baseURL.javaApi}/api/demoAppointment/queryActivityInfo?activityId=${id}`,
    method: "post",
  });
}
export function submit(data, langEnv = 2) {
  return request({
    url: `${baseURL.javaApi}/api/demoAppointment/submit`,
    method: "post",
    data
  });
}